module.exports = __webpack_public_path__ + "media/images/flags/1x1/chl-2741174c6eb2463a35dfa5d78db10d24.svg";